import { useState, useEffect, useRef } from 'react';

export const useHttp = config => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const isMountedRef = useRef(true);

  const { requestCallback, onLoad, onError } = config;

  useEffect(() => {
    // Set mounted flag
    isMountedRef.current = true;
    
    // Cleanup function
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  const request = async data => {
    // Only update state if component is mounted
    if (isMountedRef.current) {
      setLoading(true);
    }
    
    try {
      const res = await requestCallback(data);
      
      // Only update state and call callbacks if component is still mounted
      if (isMountedRef.current) {
        setLoading(false);
        await onLoad(res);
      }
      
      return res;
    } catch (error) {
      // Only update state and call callbacks if component is still mounted
      if (isMountedRef.current) {
        setLoading(false);
        setError(true);
        await onError(error);
      }
      
      // Re-throw the error to maintain the same behavior
      throw error;
    }
  };

  return { loading, error, request };
};